export default __webpack_public_path__ + "static/michael-c5b80b353d830651aac38ca4da3e1bc3.jpg";